// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1__b775d221ddfe65f0d670","cls2":"AccountMenuButton-cls2___3e5851965b14b894610 AccountMenuButton-cls1__b775d221ddfe65f0d670"};